<script>
  import Layout from '/components/Layout.svelte';
  import DiagnosticTable from '/components/DiagnosticTable.svelte';
  import { inertia } from '@inertiajs/svelte';

  export let invalid_sources = [];
  export let total_refs = 0;

  const REF_LABELS = {
    enable_event: 'enables',
    disable_event: 'disables',
    trigger_event: 'triggers',
    schedule_event: 'schedules',
    skill_check_on_success: 'on success →',
    skill_check_on_failure: 'on failure →',
    skill_check_on_complication: 'on complication →',
    condition_event_triggered: 'requires triggered',
    condition_event_not_triggered: 'requires not triggered',
    condition_previous_event: 'requires previous',
    condition_player_choice: 'requires choice in',
  };
  function refLabel(t) { return REF_LABELS[t] ?? t.replace(/_/g, ' '); }

  $: tableRows = invalid_sources.map(r => ({ path: r.source_path, cells: r }));
</script>

<svelte:head>
  <title>Invalid Event References — Diagnostics</title>
</svelte:head>

<Layout title="Invalid Event References">
  <div class="toolbar">
    <a use:inertia href="/" class="back-link">← Dashboard</a>
  </div>

  {#if invalid_sources.length === 0}
    <div class="all-clear">
      <span class="all-clear-icon">✓</span>
      All event references are valid.
    </div>
  {:else}
    <p class="summary">
      {invalid_sources.length} events contain {total_refs} references to event IDs that don't exist.
    </p>

    <DiagnosticTable
      title="Broken event references"
      count="{invalid_sources.length} events, {total_refs} refs"
      headers={['Source event', 'Broken references']}
      rows={tableRows}
      filename="invalid_event_references"
    >
      {#each invalid_sources as row}
        <tr>
          <td class="source-cell">
            <a use:inertia href="/editor/events/{row.source_path}" class="event-link">{row.source_event_id}</a>
          </td>
          <td class="pills-cell">
            {#each row.targets as t}
              <span class="broken-ref">
                <span class="ref-type">{refLabel(t.reference_type)}</span>
                <span class="broken-id">{t.event_id}</span>
              </span>
            {/each}
          </td>
        </tr>
      {/each}
    </DiagnosticTable>
  {/if}
</Layout>

<style>
  .toolbar {
    display: flex;
    margin-bottom: 1.5rem;
  }

  .back-link {
    color: #64748b;
    text-decoration: none;
    font-size: 0.9rem;
  }

  .back-link:hover { color: #1e293b; }

  .summary {
    font-size: 0.9rem;
    color: #64748b;
    margin: 0 0 1.5rem 0;
  }

  .all-clear {
    display: flex;
    align-items: center;
    gap: 0.625rem;
    padding: 1.25rem 1.5rem;
    background: #f0fdf4;
    border: 1px solid #86efac;
    border-radius: 0.75rem;
    color: #166534;
    font-weight: 600;
  }

  .all-clear-icon { font-size: 1.1rem; }
</style>
